import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import BarArrowButton from './BarArrowButton.vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'ReLinkAccountsShoutPanel',
    setup(__props) {
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(BarArrowButton, {
                flex: true,
                large: true,
                class: "linkAccounts",
                title: "Keep Your Accounts Connected",
                href: "/#/Accounts/All/Relink",
                bgImage: require('@/assets/bg/vault.png')
            }, {
                default: _withCtx(() => _cache[0] || (_cache[0] = [
                    _createElementVNode("div", { class: "barArrowButtonSlotContent" }, [
                        _createElementVNode("a", { href: "/#/Accounts/All/Relink" }, [
                            _createElementVNode("p", null, "To keep your account data flowing smoothly, we need you to refresh the permissions for some of your connected bank accounts. This only takes a moment.")
                        ])
                    ], -1)
                ])),
                _: 1
            }, 8, ["bgImage"]));
        };
    }
});
